import type { FaireProductEntity } from "../../entity_types/product";

export const p_tmvyub8jfd: FaireProductEntity = {
  token: "p_tmvyub8jfd",
  type: "product",
  name: "Albers Short Sleeve Sweater Tee - Cortado",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/791375f252e2ea4184281c2084fd7b956f1d8be9134ee8a04ce98e30b5cbbb50.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f7e65d7a502ceac8acc7215768f6d87b107d110713ad42b7a5f0a4c2eb97b014.jpeg",
    "https://cdn.faire.com/fastly/03c3286e75cf574cee6ec671d7f436f86d2bfabc5396599be3792671b202a50b.jpeg",
    "https://cdn.faire.com/fastly/d68f3f8de6600b656c4ae334a8ce7211d2ef9d98769eb3f79882ba32b7898aa6.jpeg",
    "https://cdn.faire.com/fastly/830482d6775ea26308c690a5196ddfa017303be14004b8ecdfde0f1f1b2c878d.jpeg",
    "https://cdn.faire.com/fastly/c47fae695dfd66ace434c2e0665a31f798071fd6143e1b0c0cf278075d6bdc12.jpeg",
    "https://cdn.faire.com/fastly/c966b48c72e98900aa5577a0b4204a3cd0487f1cf4435f297150c1026f3933df.jpeg"
  ],
  priceDollars: 75.6,
  description: "A relaxed fit with a more structured feel. The Albers Tee holds its shape with a firm, flat hand, creating clean, architectural lines that feel intentional from every angle. Inspired by the Bauhaus movement and the work of Josef Albers, color is arranged with quiet precision through blocks and grids that feel balanced and considered. Designed as a companion to the Bauhaus, it carries the same visual language in a form that layers easily and moves across wardrobes with flexibility.\n\n• 100% Pima cotton\n• Relaxed, boxy fit with drop shoulder\n• Minimal drape with a flat, slightly firm feel\n• Designed for easy layering\n• Holds its shape over time, maintaining a clean silhouette\n• Artisan made in Peru under Fair Trade practices",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:30.835Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
